import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.typed-array.at.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.typed-array.find-last.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.typed-array.find-last-index.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.typed-array.to-reversed.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.typed-array.to-sorted.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.typed-array.with.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.array-buffer.detached.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.array-buffer.transfer.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.array-buffer.transfer-to-fixed-length.mjs';

function getSecureMathRandomBrowser() {
  const array = new Uint32Array(1);
  const maxNumber = Math.pow(2, 32) - 1;
  if (typeof window.msCrypto !== 'undefined') {
    return window.msCrypto.getRandomValues(array)[0] / maxNumber;
  }
  if (typeof window.crypto !== 'undefined') {
    return window.crypto.getRandomValues(array)[0] / maxNumber;
  }

  // eslint-disable-next-line no-console
  console.log(`fail to generate secure random. Neither window.msCrypto nor window.crypto is defined in window`);
  return Math.random();
}

export { getSecureMathRandomBrowser };
